import { render, staticRenderFns } from "./OperationInspectionRecordInfo.vue?vue&type=template&id=f95917f6&scoped=true"
import script from "./OperationInspectionRecordInfo.vue?vue&type=script&lang=js"
export * from "./OperationInspectionRecordInfo.vue?vue&type=script&lang=js"
import style0 from "./OperationInspectionRecordInfo.vue?vue&type=style&index=0&id=f95917f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f95917f6",
  null
  
)

export default component.exports